<div class="modal-header"><h3 class="modal-title fw-light">Session Expired</h3></div>
<div class="modal-body">
  <div class="alert alert-danger" *ngIf="error"><div>A login error occurred</div></div>
  <p>It looks like your session has expired.</p>
  <div>Please click the button below.</div>
</div>
<div class="modal-footer">
  <button class="btn btn-primary d-block w-100" (click)="login()" [disabled]="waiting">Login</button>
</div>
